import { render, staticRenderFns } from "./orderSaleDataDivideGoods.vue?vue&type=template&id=33c28e27&scoped=true&"
import script from "./orderSaleDataDivideGoods.vue?vue&type=script&lang=js&"
export * from "./orderSaleDataDivideGoods.vue?vue&type=script&lang=js&"
import style0 from "./orderSaleDataDivideGoods.vue?vue&type=style&index=0&id=33c28e27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c28e27",
  null
  
)

component.options.__file = "orderSaleDataDivideGoods.vue"
export default component.exports